import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { ServerApi } from "./helpers/api-instance";

import "vant/lib/index.css";

const app = createApp(App);

app.provide(ServerApi.InjectionKey, new ServerApi());

app.use(router);
app.mount("#app");
